import { useRef, useState } from "react";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { successMessage } from "../../utils/toastify-message/ToastifyMessage";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";
import { useSelector } from "react-redux";

export default function AffiliateEnrollmentFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  const deleteUser = () => {
    setUser("");
    filterDataHandler({ page: 1, user: "" });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="admin-filter-grid">
        <div className="relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full"
          ></span>
          {user ? (
            <PiXFill
              className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user}
            onChange={(e) => setUser(e.target.value)}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
        <div className="flex flex-col">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            رتبه
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, level: e.target.value })
            }
            id="role-select"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-200 ease-in-out dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value="">همه ی ربته ها</option>
            {utils
              ? utils.AFFILIATE_ENROLLMENT_LEVEL_VALUES.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item?.name}
                  </option>
                ))
              : null}
          </select>
        </div>
      </div>
    </div>
  );
}
